import { UiSchema } from "@rjsf/utils";

export const UpdateProfileUiSchema: UiSchema = {
  email: {
    "ui:widget": "email"
  }
};
